/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateUserDto = {
    /**
     * User email address
     */
    email: string;
    /**
     * User first name
     */
    firstName: string;
    /**
     * User last name
     */
    lastName: string;
    /**
     * User password (optional, required for email/password authentication)
     */
    password?: string;
    /**
     * User roles to assign. Valid values: SUPER_ADMIN, BUSINESS_ADMIN, ADVISER
     */
    roles?: Array<'SUPER_ADMIN' | 'BUSINESS_ADMIN' | 'FINANCE_ADMIN' | 'ADVISER'>;
    /**
     * FAP licence number of the Financial Advice Provider this adviser belongs to
     */
    fapLicenceNumber?: string;
    /**
     * Adviser FSPR number (stored on linked Adviser entity)
     */
    fsprNumber?: string;
    /**
     * UUID of the Adviser this user is associated with
     */
    adviserId?: string;
    /**
     * Adviser role classification
     */
    adviserRole?: CreateUserDto.adviserRole;
};
export namespace CreateUserDto {
    /**
     * Adviser role classification
     */
    export enum adviserRole {
        AUTHORISED_REP = 'AUTHORISED_REP',
        QUOTING_ADVISER = 'QUOTING_ADVISER',
        INTERNAL_ADVISER = 'INTERNAL_ADVISER',
    }
}

